import httpService from '@Utils/httpService';

const baseUrl = 'api/Management/Releases';

export default {
  // params: { status, search, page, itemsPerPage }
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  },
  // data: { name, markdown?, jiraVersionId? }
  createManual(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  // data: { jiraVersionId, name?, issueKeys[], instructions? }
  generate(data) {
    return httpService.post({
      url: `${baseUrl}/generate`,
      data,
    });
  },
  // data: { instructions? }
  regenerateDraft(id, data) {
    return httpService.post({
      url: `${baseUrl}/${id}/drafts/regenerate`,
      data,
    });
  },
  // data: { name }
  rename(id, data) {
    return httpService.patch({
      url: `${baseUrl}/${id}`,
      data,
    });
  },
  archive(id) {
    return httpService.post({
      url: `${baseUrl}/${id}/archive`,
    });
  },
  markAppReleased(id) {
    return httpService.post({
      url: `${baseUrl}/${id}/app-released`,
    });
  },
  // data: { issueKeys[] }
  updateItems(id, data) {
    return httpService.put({
      url: `${baseUrl}/${id}/items`,
      data,
    });
  },
  // data: { category?, customerTitle? }
  updateItem(id, itemId, data) {
    return httpService.patch({
      url: `${baseUrl}/${id}/items/${itemId}`,
      data,
    });
  },
  // kind: ReleaseDraftKind — customer and internal notes are separate version streams.
  getDrafts(id, kind) {
    return httpService.get({
      url: `${baseUrl}/${id}/drafts`,
      params: kind ? { kind } : undefined,
    });
  },
  getDraft(id, draftId) {
    return httpService.get({
      url: `${baseUrl}/${id}/drafts/${draftId}`,
    });
  },
  // data: { kind, baseDraftId, markdown }
  saveDraft(id, data) {
    return httpService.put({
      url: `${baseUrl}/${id}/drafts`,
      data,
    });
  },
  // Reverts within the target draft's own stream — the server reads the kind off the draft.
  revertDraft(id, draftId) {
    return httpService.post({
      url: `${baseUrl}/${id}/drafts/${draftId}/revert`,
    });
  },
  /** Re-derives the internal notes from the current customer notes plus the linked-ticket appendix. */
  rebuildInternalNotes(id) {
    return httpService.post({
      url: `${baseUrl}/${id}/internal-notes/rebuild`,
    });
  },
  // params: { search, page, itemsPerPage }
  getCompanies(params) {
    return httpService.get({
      url: `${baseUrl}/companies`,
      params,
    });
  },
  // data: { companyIds[], recipientPolicy, sendEmail, reminder? }
  publishPreview(id, data) {
    return httpService.post({
      url: `${baseUrl}/${id}/publish/preview`,
      data,
    });
  },
  // data: { companyIds[], recipientPolicy, sendEmail, reminder? }
  publish(id, data) {
    return httpService.post({
      url: `${baseUrl}/${id}/publish`,
      data,
    });
  },
  sendTest(id) {
    return httpService.post({
      url: `${baseUrl}/${id}/send-test`,
    });
  },
  getPublications(id) {
    return httpService.get({
      url: `${baseUrl}/${id}/publications`,
    });
  },
  // params: { status, page, itemsPerPage }
  getDeliveries(publicationId, params) {
    return httpService.get({
      url: `${baseUrl}/publications/${publicationId}/deliveries`,
      params,
    });
  },
  retryFailed(publicationId) {
    return httpService.post({
      url: `${baseUrl}/publications/${publicationId}/retry-failed`,
    });
  },
  getReminders(id) {
    return httpService.get({
      url: `${baseUrl}/${id}/reminders`,
    });
  },
  // data: { dueAt }
  updateReminder(id, reminderId, data) {
    return httpService.patch({
      url: `${baseUrl}/${id}/reminders/${reminderId}`,
      data,
    });
  },
  cancelReminder(id, reminderId) {
    return httpService.post({
      url: `${baseUrl}/${id}/reminders/${reminderId}/cancel`,
    });
  },
  sendReminderNow(id, reminderId) {
    return httpService.post({
      url: `${baseUrl}/${id}/reminders/${reminderId}/send-now`,
    });
  },
};
